
import { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface PageLayoutProps {
  children: ReactNode;
  hasHero?: boolean;
}

export default function PageLayout({ children, hasHero = false }: PageLayoutProps) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className={hasHero ? '' : 'pt-20'}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
